import type { ThemeMode } from '@creditornot/cb-utils';

import { colors } from './colors';

export type SemanticColors = {
  /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
  a11yFocusIndicator: string;
  /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
  borderLight: string;
  /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
  borderPrimary: string;
  /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
  surfaceMain: string;
  /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
  textPrimary: string;
  /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
  textSecondary: string;
  /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
  textTertiary: string;
};

export type SemanticColor = keyof SemanticColors;

/** @deprecated use color tokens from `@creditornot/cb-ingredients/design-tokens` instead */
export const semanticColors: Record<ThemeMode, SemanticColors> = {
  light: {
    /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
    textPrimary: colors.pepper100,
    /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
    textSecondary: colors.pepper64,
    /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
    textTertiary: colors.pepper40,
    /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
    surfaceMain: colors.salt100,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderPrimary: colors.pepper12,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderLight: colors.pepper12,
    /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
    a11yFocusIndicator: colors.nightSky100,
  },
  lightHighContrast: {
    /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
    textPrimary: colors.pepper100,
    /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
    textSecondary: colors.pepper80,
    /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
    textTertiary: colors.pepper80,
    /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
    surfaceMain: colors.salt100,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderPrimary: colors.pepper80,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderLight: colors.pepper80,
    /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
    a11yFocusIndicator: colors.nightSky100,
  },
  dark: {
    /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
    textPrimary: colors.salt100,
    /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
    textSecondary: colors.salt72,
    /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
    textTertiary: colors.salt48,
    /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
    surfaceMain: '#141414',
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderPrimary: colors.salt16,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderLight: colors.salt16,
    /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
    a11yFocusIndicator: colors.banana100,
  },
};

Object.freeze(semanticColors);
